import { useQuery } from '@hooks/reactQuery';

import { getAssetOwners } from '@api/assetsRent';

import { generateSelectOptions } from '@utils/generateSelectOptions/generateSelectOptions';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { GET_ASSET_OWNERS } from '@constants/queryKeys';

interface IUseQueryAssetOwnersReturnType {
	assetOwners: Array<TSelectOption>;
	isLoadingAssetOwners: boolean;
}

export const useQueryAssetOwners = (isAO: boolean): IUseQueryAssetOwnersReturnType => {
	const {
		data: assetOwners,
		isInitialLoading,
	} = useQuery({
		queryKey: [GET_ASSET_OWNERS],
		queryFn: getAssetOwners,
		refetchOnWindowFocus: false,
		enabled: [!isAO],
	});

	return {
		assetOwners: generateSelectOptions({ data: assetOwners, value: 'id', label: 'name' }),
		isLoadingAssetOwners: isInitialLoading,
	};
};
